/* HelloSpicy — scripts extraits de sections/hs-instagram-embed.liquid (audit A23 : sortis du HTML pour l'alléger et les mettre en cache). */
(function () {
    var SELECTEUR = 'blockquote.instagram-media';
    if (!document.querySelector(SELECTEUR)) return;

    var essais = 0;
    var MAX_ESSAIS = 40; // 40 × 250 ms = 10 s

    // (b) RECONSTRUCTION DU PERMALINK — voir la cause racine en tête de fichier.
    // On ne touche QUE les blockquotes qui n'ont pas déjà l'attribut : reposer
    // un permalink sur un embed déjà valide n'apporterait rien et risquerait
    // d'écraser une valeur correcte.
    function reconstruire() {
      var repares = 0;
      var candidats = document.querySelectorAll(SELECTEUR + ':not([data-instgrm-permalink])');
      Array.prototype.forEach.call(candidats, function (bq) {
        var a = bq.querySelector(
          'a[href*="instagram.com/p/"], a[href*="instagram.com/reel/"], a[href*="instagram.com/tv/"]'
        );
        if (!a) return;
        // Les paramètres de suivi collés par Instagram (?utm_source=ig_embed…)
        // ne font pas partie du permalink attendu par le script.
        var url = a.getAttribute('href').split('?')[0];
        if (url.charAt(url.length - 1) !== '/') url += '/';
        bq.setAttribute('data-instgrm-permalink', url);
        if (!bq.hasAttribute('data-instgrm-version')) {
          bq.setAttribute('data-instgrm-version', '14');
        }
        repares++;
      });
      return repares;
    }

    function traiter() {
      if (window.instgrm && window.instgrm.Embeds && window.instgrm.Embeds.process) {
        try { window.instgrm.Embeds.process(); } catch (e) {}
        return true;
      }
      return false;
    }

    function traiterAvecReprises() {
      if (traiter()) return;
      if (++essais > MAX_ESSAIS) return;
      setTimeout(traiterAvecReprises, 250);
    }

    // L'ordre compte : les attributs doivent être en place avant qu'embed.js ne
    // s'exécute.
    reconstruire();

    // (c) charger embed.js seulement s'il manque.
    if (!document.querySelector('script[src*="instagram.com/embed.js"]')) {
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.instagram.com/embed.js';
      s.onload = traiter;
      document.head.appendChild(s);
    }

    // (d) rattraper la course async/rendu.
    traiterAvecReprises();

    // (e) un onglet en arrière-plan suspend le travail d'Instagram : on repasse
    // au load et au retour de l'onglet. Un blockquote non transformé n'a pas
    // d'attribut data-instgrm-payload-id — c'est le test le moins coûteux.
    function repasser() {
      var restants = document.querySelectorAll(SELECTEUR + ':not([data-instgrm-payload-id])');
      if (!restants.length) return;
      reconstruire();
      traiter();
    }
    window.addEventListener('load', repasser);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') repasser();
    });
  })();
